module.exports = __webpack_public_path__ + "img/jeni-sandy-mac.114acef9.png";